import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSelect from "Common/Custom/FormSelect";
import FormInputFile from "Common/Custom/FormInputFile";

// Uses `fields` prop from parent — does not re-import JSON directly
// roomList fetched in parent (EditHallImages) — not inside this form
const EditHallImagesForm = ({
    fields = [],
    values,
    errors,
    handleChange,
    handleFileChange,
    handleSubmit,
    loading,
    imagePreview,
    roomList = [],
    title = "Update Hall Image",
}) => {
    return (
        <PageBody
            onSubmit={handleSubmit}
            headerchildren={<HeadingOne>{title}</HeadingOne>}
        >
            {fields.map((field) => {
                if (field.type === "file") {
                    return (
                        <FormInputFile
                            key={field.name}
                            field={field}
                            handleChange={handleFileChange}
                            error={errors.hall_image}
                            imagePreview={imagePreview}
                        />
                    );
                }
                if (field.type === "select") {
                    const options = roomList.map((opt) => ({
                        value: opt.id,
                        label: opt.hallroom_type,
                    }));
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={options}
                            error={errors[field.name]}
                        />
                    );
                }
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Update Hall Image"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default EditHallImagesForm;
